import React, { useEffect, useState } from "react";
import { useCurrencyFormat } from "../../../hooks/useCurrencyFormat";
import { getBalance } from "../../../api/currency";
import { size } from "lodash";

const FBannerSpend = ({ imageUrl, title, description }) => {
  const [saldo, setSaldo] = useState(0);
  const { formatWithCurrencyISO } = useCurrencyFormat();

  useEffect(() => {
    (async () => {
      const { data } = await getBalance();
      ////console.log(data.data.balances.availableAmount)
      if (size(data) > 0) {
        setSaldo(data.data.balances.availableAmount);
      } else {
        setSaldo([]);
      }
    })();
  }, []);

  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] text-[4vw] smm:text-[20px] place-items-center">
          <div className="border-0 col-span-5">
            <img
              src={imageUrl}
              className="w-full xxs:w-[150px] h-auto flex-1"
            />
          </div>
          <div className="border-0 col-span-7 grid grid-rows-3 text-center py-3 sm:py-7">
            <div className="border-0 row-span-1 font-bold">{title}</div>
            <div className="border-0 row-span-1 leading-[30px] font-semibold text-Secondary">
              {formatWithCurrencyISO(saldo, "484")}
            </div>
            <div className="border-0 row-span-1 leading-[30px] font-regular">
              {description}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FBannerSpend;
